import React, { Component, useEffect, useState } from 'react';
import HomeContainer from '../containers/HomeContainerNew/HomeContainerNew';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import cookie from 'react-cookies';
import Footer from 'components/Footer';
import { detectMobile } from 'utils/UiHelper';
import { NotificationManager } from 'react-notifications';
import { checkURL } from '../utils/Helper';
import { MitIdSuccessHandler } from '../components/MitId/MitIdSuccessHandler';
import {
    checkUserLoggedStatus,
    checkSession as CheckSession,
    showLastLoginPopupStatus as ShowLastLoginPopupStatus,
    reset,
} from '../actions/AuthActions';
import { ContainerWidthProvider } from '../contexts/ContainerWidthContext';
import { ContentBlock, ContentWrapper } from './styled';

const HomePage = (props) => {
    const [isGoogleConversionSent, setIsGoogleConversionSent] = useState(false);

    const checkMitidRedirect = () => {
        if (checkURL('mitid-verify/success')) {
            MitIdSuccessHandler(
                props.params,
                props.checkUserLoggedStatus,
                props.auth?.user?.userId,
                () => {
                    props.checkSession(true);
                }
            );
        }

        if (checkURL('/mitid-verify/error')) {
            const url = new URL(window.location.href);
            const reason = url.searchParams.get('error');
            NotificationManager.error(reason);
        }
    };

    useEffect(() => {
        if (cookie.load('hide-highlights')) {
            props.uiActions.setHighlightStatus(false);
        }

        checkMitidRedirect();
        window.google_conversion_id = 852277327;
        window.google_conversion_language = 'en';
        window.google_conversion_format = '3';
        window.google_conversion_color = 'ffffff';
        window.google_conversion_label = 'lqurCPG9sHEQz_CylgM';
        window.google_remarketing_only = false;
    }, []);

    useEffect(
        () => {
            if (props.auth.attachedMitIdUser) {
                if (props.auth.attachedMitIdUser) {
                    props.showLastLoginPopupStatus(true);
                }
            }
        },
        [props.auth.attachedMitIdUser]
    );

    let trackCode = '';

    if (!isGoogleConversionSent && window.location.pathname === '/velkommen') {
        setIsGoogleConversionSent(true);

        trackCode =
            window.location.pathname === '/velkommen' ? (
                <div>
                    <script
                        type="text/javascript"
                        src="//www.googleadservices.com/pagead/conversion.js"
                    />
                    <noscript>
                        <div>
                            <img
                                height="1"
                                width="1"
                                alt=""
                                src="//www.googleadservices.com/pagead/conversion/852277327/?label=lqurCPG9sHEQz_CylgM&amp;guid=ON&amp;script=0"
                            />
                        </div>
                    </noscript>
                </div>
            ) : null;
    }

    return (
        <div className="home-page">
            <ContentWrapper
                isLeftSideBarOpen={props.isLeftSideBarOpen}
                isMobile={detectMobile()}
            >
                <ContainerWidthProvider>
                    <ContentBlock>
                        <HomeContainer />
                    </ContentBlock>
                </ContainerWidthProvider>
            </ContentWrapper>

            {trackCode}

            {detectMobile() ? <Footer /> : null}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        sportActiveTab: state.ui.sportActiveTab,
        highlightStatus: state.ui.highlightStatus,
        betslip: state.betslip,
        auth: state?.auth,
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        authReset: bindActionCreators(reset, dispatch),
        checkUserLoggedStatus: () => dispatch(checkUserLoggedStatus()),
        checkSession: (mitId) => dispatch(CheckSession(mitId)),
        showLastLoginPopupStatus: bindActionCreators(
            ShowLastLoginPopupStatus,
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage);
